<template>
  <div id="RouteManagement">
    <v-container fluid>
      <v-card class="elevation-0" height="70">
        <v-card-title>
          <v-row>
            <v-col class="pa-0 pl-4" cols="auto">
              <span class="text-h6">Routes ({{ routes.length }})</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="pa-0" cols="2">
              <v-text-field clearable dense label="Search" outlined v-model="search"></v-text-field>
            </v-col>
            <!--            <v-col class="pa-0 ml-5 mr-1" cols="auto">-->
            <!--              <v-btn @click="startCreateRoute" class="primary elevation-0" fab small>-->
            <!--                <v-icon>mdi-plus</v-icon>-->
            <!--              </v-btn>-->
            <!--            </v-col>-->
          </v-row>
        </v-card-title>
      </v-card>
      <v-row>
        <v-col class="px-5" cols="12">
          <v-data-table fixed-header height="calc(100vh - 320px)" @click:row="editRouteDetails" :headers="headers" :items="routes" class="elevation-0"
                        :footer-props="{itemsPerPageOptions:[25,50,100]}" :items-per-page="25" :search="search">
            <template v-slot:no-data>No Routes Available</template>
            <template v-slot:no-results>No Routes Available</template>
            <template v-slot:item.name="{ item }">
              {{ item.name ? item.name : '-' }}
            </template>
            <template v-slot:item.driver="{ item }">
              {{ item.Driver ? item.Driver.name : '-' }}
            </template>
            <template v-slot:item.vehicle="{ item }">
              {{ item.Vehicle ? item.Vehicle.name : '-' }}
            </template>
            <template v-slot:item.routeShops="{ item }">
              {{ item.RouteShops.length }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ dateTimeFilter(item.created_at) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu nudge-bottom="25">
                <template v-slot:activator="{ on:menu }">
                  <v-btn icon v-on="{...menu}">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item :key="i" @click="onClickAction(action,item)" dense
                               v-for="(action, i) in actionArr">
                    <v-list-item-title> {{ action.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <CreateUpdateRoute :route="selectedRoute" :routeDialog="routeDialog" @cancel="routeDialog=false"
                       @saveRoute="saveRoute" v-if="routeDialog"></CreateUpdateRoute>
    <CreateUpdateRouteDetails @saveRoute="saveRoute" :route="selectedRoute" :routeDetailDialog="editRouteDetailDialog"
                              @cancel="editRouteDetailDialog=false"
                              v-if="editRouteDetailDialog"></CreateUpdateRouteDetails>
    <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false;confirmMsg = 'Confirm! '"
                        @confirm="confirmAction" v-if="confirmationDialog"></ConfirmationDialog>
    <Snackbar :toaster="toaster"></Snackbar>
  </div>
</template>

<script>
import ConfirmationDialog from '../Common/ConfirmationDialog'
import Snackbar from '../Common/Snackbar'
import CreateUpdateRoute from './CreateUpdateRoute'
import { SUBSCRIBE_ROUTES } from '../../graphql/subscriptions/Routes'
import { deleteRecordById } from '@/graphql/mutations/Common'
import CreateUpdateRouteDetails from '@/components/RouteManagement/CreateUpdateRouteDetails'

export default {
  name: 'RouteManagement',
  components: { CreateUpdateRouteDetails, CreateUpdateRoute, Snackbar, ConfirmationDialog },
  data () {
    return {
      search: '', selectedRoute: {},
      routeDialog: false, editRouteDetailDialog: false, confirmationDialog: false,
      toaster: { enable: false, color: 'green', message: '' }, confirmMsg: 'Confirm! ',
      routes: [], loggedInUser: JSON.parse(localStorage.user),
      headers: [
        { text: 'Name', value: 'name' }, { text: 'Salesman', value: 'driver' },
        { text: 'Vehicle', value: 'vehicle' }, { text: 'Total Shops', value: 'routeShops' },
        { text: 'Created On', value: 'created_at' }, { text: 'Actions', value: 'actions' },
      ],
      actionArr: [{ id: '1', title: 'Edit' }, { id: '2', title: 'Delete' }, { id: '3', title: 'View Details' }],
    }
  },
  apollo: {
    $subscribe: {
      Routes: {
        query: SUBSCRIBE_ROUTES, fetchPolicy: 'network-only',
        skip () { return !this.loggedInUser },
        variables () { return { orgId: this.loggedInUser.organizationId } },
        result ({ data, loading }) {
          if (!loading) { this.routes = data.Routes }
        },
      },
    },
  },
  methods: {
    onClickAction (selectedAction, selectedRoute) {
      this.selectedRoute = selectedRoute
      this.selectedAction = this.actionArr.filter(action => selectedAction.id === action.id)[0]
      if (this.selectedAction.id === '1')
        this.confirmAction()
      else if (this.selectedAction.id === '2')
        this.confirmMsg = this.confirmMsg.concat('Are you sure want to delete this route?')
      else if (this.selectedAction.id === '3')
        this.confirmAction()
      this.confirmationDialog = this.selectedAction.id === '2'
    },
    confirmAction () {
      this.confirmationDialog = false
      this.confirmMsg = 'Confirm! '
      if (this.selectedAction.id === '1')
        this.updateRoute()
      else if (this.selectedAction.id === '2')
        this.deleteRoute()
      else if (this.selectedAction.id === '3')
        this.detailRoute()
    },
    startCreateRoute () {
      this.selectedRoute = null
      this.routeDialog = true
    },
    updateRoute () {
      this.routeDialog = true
    },
    editRouteDetails (obj) {
      this.selectedRoute = obj
      this.editRouteDetailDialog = true
    },
    detailRoute () {
      this.editRouteDetailDialog = true
    },
    saveRoute () {
      this.toaster = {
        enable: true, color: 'green',
        message: `Route ${this.selectedRoute ? 'updated' : 'created'} successfully`,
      }
      this.routeDialog = false
    },
    async deleteRoute () {
      let response = await deleteRecordById(this, this.selectedRoute.id, 'Routes')
      if (response.data) {
        this.toaster = { enable: true, color: 'green', message: 'Route successfully deleted' }
      }
    },
  },
}
</script>

<style scoped>
.v-list {
  padding: 0;
}

/deep/ tr {
  cursor: pointer;
}
</style>
